//TODO: Use mature date component
import React, { useState, useEffect } from "react";
import { getAgeFromDate, parseNumberFromAnotherLocale } from "../utils";

//TODO: Component name to be refactored to DateInput
function DOB({ onChange, initValue }) {
  const minAge = 1;
  const maxAge = 123;
  const [age, setAge] = useState(
    initValue && initValue.hasOwnProperty("date")
      ? getAgeFromDate(initValue["date"])
      : ""
  );
  const currentYear = new Date().getFullYear();

  const updateDate = (year) => {
    const formattedDate = `${year}/01/01`;
    onChange(formattedDate);
  };

  const ageChanged = (el) => {
    let _input = el.target.value;
    if (_input) {
      _input = parseInt(parseNumberFromAnotherLocale(el.target.value));
    }
    setAge(_input);
    if (_input >= minAge && _input <= maxAge) {
      updateDate(currentYear - _input);
    } else {
      onChange(null);
    }
  };

  return (
    <>
      <div className="field_group field_lbl_active">
        <input
          className="field_input"
          type="number"
          id="age"
          name="age"
          min={minAge}
          max={maxAge}
          onChange={ageChanged}
          value={age}
        />
      </div>
    </>
  );
}

export default DOB;
